import { OfficeTranslationKey } from "i18n/officeTranslations";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import React from "react";

interface Props {
    canConfigure: boolean;
    titleKey: OfficeTranslationKey;
    onConfigure: () => void;
    onDuplicate: () => void;
    onRemove: () => void;
}

const DashboardWidgetControls: React.FC<Props> = ({ canConfigure, titleKey, onConfigure, onDuplicate, onRemove }) => {
    const { t } = useOfficeTranslation();
    const title = t(titleKey);
    return <div className="dashboard-widget-controls" role="toolbar" aria-label={t("dashboard.editor.widgetActions", { name: title })}>
        <button
            type="button"
            className="btn btn-light dashboard-widget-control dashboard-widget-drag-handle"
            aria-label={t("dashboard.editor.dragWidget", { name: title })}
            title={t("dashboard.editor.dragWidget", { name: title })}
        >
            <i className="mdi mdi-drag" aria-hidden="true" />
        </button>
        {canConfigure && <button type="button" className="btn btn-light dashboard-widget-control" onClick={onConfigure} aria-label={t("dashboard.editor.configureWidget", { name: title })}>
            <i className="mdi mdi-cog-outline" aria-hidden="true" />
        </button>}
        <button type="button" className="btn btn-light dashboard-widget-control" onClick={onDuplicate} aria-label={t("dashboard.editor.duplicateWidget", { name: title })}>
            <i className="mdi mdi-content-copy" aria-hidden="true" />
        </button>
        <button type="button" className="btn btn-light dashboard-widget-control text-danger" onClick={onRemove} aria-label={t("dashboard.editor.removeWidget", { name: title })}>
            <i className="mdi mdi-close" aria-hidden="true" />
        </button>
    </div>;
};

export default DashboardWidgetControls;
